import { React } from 'react';

const Next = () => {
    return (
<svg width="64" height="64" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_53_48)">
<circle r="31.5" transform="matrix(-1 0 0 1 37 35)" stroke="#85B9E9" strokeWidth="3"/>
<path d="M18.5625 32.4304H48.9538L39.6519 21.22C39.2169 20.6949 39.0077 20.018 39.0701 19.3381C39.1326 18.6582 39.4617 18.031 39.985 17.5946C40.5083 17.1582 41.183 16.9482 41.8606 17.0109C42.5381 17.0736 43.1632 17.4038 43.5981 17.9289L56.4106 33.356C56.4968 33.4787 56.5739 33.6077 56.6413 33.7417C56.6413 33.8703 56.6412 33.9474 56.8206 34.076C56.9368 34.3708 56.9976 34.6846 57 35.0016C56.9976 35.3186 56.9368 35.6324 56.8206 35.9272C56.8206 36.0558 56.8206 36.1329 56.6413 36.2615C56.5739 36.3956 56.4968 36.5245 56.4106 36.6472L43.5981 52.0744C43.3572 52.3646 43.0555 52.598 42.7145 52.758C42.3734 52.918 42.0015 53.0006 41.625 53C41.0263 53.0012 40.446 52.7919 39.985 52.4086C39.7255 52.1928 39.511 51.9277 39.3538 51.6285C39.1966 51.3294 39.0998 51.002 39.0688 50.6653C39.0379 50.3285 39.0734 49.9889 39.1735 49.666C39.2735 49.343 39.4361 49.043 39.6519 48.7832L48.9538 37.5728H18.5625C17.8829 37.5728 17.2311 37.3019 16.7505 36.8197C16.27 36.3375 16 35.6835 16 35.0016C16 34.3197 16.27 33.6657 16.7505 33.1835C17.2311 32.7013 17.8829 32.4304 18.5625 32.4304Z" fill="#85B9E9"/>
</g>
<defs>
<filter id="filter0_d_53_48" x="0" y="0" width="74" height="74" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_53_48"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_53_48" result="shape"/>
</filter>
</defs>
</svg>


    )
}

export default Next